import { TableBody } from "@mui/material";
import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

function Row(props) {
  // const { data, total, name } = props;
  const { total, name, currency } = props;
  // const [open, setOpen] = React.useState(true);
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        {/* <TableCell>
            {data !== undefined ? (
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            ) : null}
          </TableCell> */}
        <TableCell component="th" scope="row">
          {name}
        </TableCell>
        <TableCell align="right">
          {currency}. {total.toLocaleString()}
        </TableCell>
      </TableRow>
      {/* {data !== undefined ? (
          <TableRow>
            <TableCell
              style={{
                paddingBottom: 0,
                paddingTop: 0,
                paddingRight: 0,
                paddingLeft: 0,
              }}
              colSpan={6}
            >
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ marginLeft: 0 }}>
                  <Table size="medium" aria-label="purchases">
                    <TableBody>
                      {Object.keys(data).map((key) => {
                        return (
                          <TableRow>
                            <TableCell align="center">{key}</TableCell>
                            <TableCell align="right">
                              Ksh. {data[key].toLocaleString()}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
        ) : null} */}
    </React.Fragment>
  );
}

export default function InsuranceIncomeStatementTableBody({ data }) {
  return (
    <TableBody>
      {data["Gross Premium Written"] !== undefined ? (
        <Row
          name="Gross Premium Written"
          key="Gross Premium Written"
          total={data["Gross Premium Written"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Gross Premium Income"] !== undefined ? (
        <Row
          name="Gross Premium Income"
          key="Gross Premium Income"
          total={data["Gross Premium Income"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Premium Ceded To Reinsurers"] !== undefined ? (
        <Row
          name="Premium Ceded To Reinsurers"
          key="Premium Ceded To Reinsurers"
          total={data["Premium Ceded To Reinsurers"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Net Premium Income"] !== undefined ? (
        <Row
          name="Net Premium Income"
          key="Net Premium Income"
          total={data["Net Premium Income"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Fees And Commission Income"] !== undefined ? (
        <Row
          name="Fees And Commission Income"
          key="Fees And Commission Income"
          total={data["Fees And Commission Income"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Commission Income"] !== undefined ? (
        <Row
          name="Commission Income"
          key="Commission Income"
          total={data["Commission Income"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Fees Income"] !== undefined ? (
        <Row
          name="Fees Income"
          key="Fees Income"
          total={data["Fees Income"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Investment Income"] !== undefined ? (
        <Row
          name="Investment Income"
          key="Investment Income"
          total={data["Investment Income"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data[
        "Net Fair Value Loss On Financial Assets At Fair Value Through Profit Or Loss"
      ] !== undefined ? (
        <Row
          name="Net Fair Value Loss On Financial Assets At Fair Value Through Profit Or Loss"
          key="Net Fair Value Loss On Financial Assets At Fair Value Through Profit Or Loss"
          total={
            data[
              "Net Fair Value Loss On Financial Assets At Fair Value Through Profit Or Loss"
            ]
          }
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Impairment Of Financial Assets"] !== undefined ? (
        <Row
          name="Impairment Of Financial Assets"
          key="Impairment Of Financial Assets"
          total={data["Impairment Of Financial Assets"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data[
        "Negative Goodwill On Acquisition Of Minority Shares In A Subsidiary"
      ] !== undefined ? (
        <Row
          name="Negative Goodwill On Acquisition Of Minority Shares In A Subsidiary"
          key="Negative Goodwill On Acquisition Of Minority Shares In A Subsidiary"
          total={
            data[
              "Negative Goodwill On Acquisition Of Minority Shares In A Subsidiary"
            ]
          }
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}

      {data["Other Income"] !== undefined ? (
        <Row
          name="Other Income"
          key="Other Income"
          total={data["Other Income"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Other Operating Revenue"] !== undefined ? (
        <Row
          name="Other Operating Revenue"
          key="Other Operating Revenue"
          total={data["Other Operating Revenue"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Total Other Revenue"] !== undefined ? (
        <Row
          name="Total Other Revenue"
          key="Total Other Revenue"
          total={data["Total Other Revenue"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Total Revenue"] !== undefined ? (
        <Row
          name="Total Revenue"
          key="Total Revenue"
          total={data["Total Revenue"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Claims And Policy Holders' Benefits Expense"] !== undefined ? (
        <Row
          name="Claims And Policy Holders' Benefits Expense"
          key="Claims And Policy Holders' Benefits Expense"
          total={data["Claims And Policy Holders' Benefits Expense"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data[
        "Reinsurer's Share Of Claims And Policy Holders' Benefit Expense"
      ] !== undefined ? (
        <Row
          name="Reinsurer's Share Of Claims And Policy Holders' Benefit Expense"
          key="Reinsurer's Share Of Claims And Policy Holders' Benefit Expense"
          total={
            data[
              "Reinsurer's Share Of Claims And Policy Holders' Benefit Expense"
            ]
          }
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Claims Recoverable From Re-Insurers"] !== undefined ? (
        <Row
          name="Claims Recoverable From Re-Insurers"
          key="Claims Recoverable From Re-Insurers"
          total={data["Claims Recoverable From Re-Insurers"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Return To Holders Of Investment Contract Liabilities"] !==
      undefined ? (
        <Row
          name="Return To Holders Of Investment Contract Liabilities"
          key="Return To Holders Of Investment Contract Liabilities"
          total={data["Return To Holders Of Investment Contract Liabilities"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data[
        "Net Insurance Benefits And Return To Holders Of Investment Contracts"
      ] !== undefined ? (
        <Row
          name="Net Insurance Benefits And Return To Holders Of Investment Contracts"
          key="Net Insurance Benefits And Return To Holders Of Investment Contracts"
          total={
            data[
              "Net Insurance Benefits And Return To Holders Of Investment Contracts"
            ]
          }
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Net Insurance Benefits And Claims"] !== undefined ? (
        <Row
          name="Net Insurance Benefits And Claims"
          key="Net Insurance Benefits And Claims"
          total={data["Net Insurance Benefits And Claims"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Gross Benefits And Claims Paid"] !== undefined ? (
        <Row
          name="Gross Benefits And Claims Paid"
          key="Gross Benefits And Claims Paid"
          total={data["Gross Benefits And Claims Paid"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Claims Ceded To Reinsurers"] !== undefined ? (
        <Row
          name="Claims Ceded To Reinsurers"
          key="Claims Ceded To Reinsurers"
          total={data["Claims Ceded To Reinsurers"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Gross Change In Insurance Contract Liabilities"] !== undefined ? (
        <Row
          name="Gross Change In Insurance Contract Liabilities"
          key="Gross Change In Insurance Contract Liabilities"
          total={data["Gross Change In Insurance Contract Liabilities"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Gross Change In Investment Contract Liabilities"] !== undefined ? (
        <Row
          name="Gross Change In Investment Contract Liabilities"
          key="Gross Change In Investment Contract Liabilities"
          total={data["Gross Change In Investment Contract Liabilities"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Change In Contract Liabilities Ceded To Reinsurers"] !==
      undefined ? (
        <Row
          name="Change In Contract Liabilities Ceded To Reinsurers"
          key="Change In Contract Liabilities Ceded To Reinsurers"
          total={data["Change In Contract Liabilities Ceded To Reinsurers"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Net Benefits And Claims"] !== undefined ? (
        <Row
          name="Net Benefits And Claims"
          key="Net Benefits And Claims"
          total={data["Net Benefits And Claims"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Fees And Commission Expense"] !== undefined ? (
        <Row
          name="Fees And Commission Expense"
          key="Fees And Commission Expense"
          total={data["Fees And Commission Expense"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Commission Expense"] !== undefined ? (
        <Row
          name="Commission Expense"
          key="Commission Expense"
          total={data["Commission Expense"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Cost of Sales"] !== undefined ? (
        <Row
          name="Cost of Sales"
          key="Cost of Sales"
          total={data["Cost of Sales"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Cost of Sales(Inventory)"] !== undefined ? (
        <Row
          name="Cost of Sales(Inventory)"
          key="Cost of Sales(Inventory)"
          total={data["Cost of Sales(Inventory)"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Cost of Sales(Plots)"] !== undefined ? (
        <Row
          name="Cost of Sales(Plots)"
          key="Cost of Sales(Plots)"
          total={data["Cost of Sales(Plots)"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Operating Expenses"] !== undefined ? (
        <Row
          name="Operating Expenses"
          key="Operating Expenses"
          total={data["Operating Expenses"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Impairment of Investment In Subsidiaries And Associate"] !==
      undefined ? (
        <Row
          name="Impairment of Investment In Subsidiaries And Associate"
          key="Impairment of Investment In Subsidiaries And Associate"
          total={data["Impairment of Investment In Subsidiaries And Associate"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Impairment Of Goodwill"] !== undefined ? (
        <Row
          name="Impairment Of Goodwill"
          key="Impairment Of Goodwill"
          total={data["Impairment Of Goodwill"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Total Expenses And Commissions"] !== undefined ? (
        <Row
          name="Total Expenses And Commissions"
          key="Total Expenses And Commissions"
          total={data["Total Expenses And Commissions"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Operating Profit"] !== undefined ? (
        <Row
          name="Operating Profit"
          key="Operating Profit"
          total={data["Operating Profit"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Finance Costs"] !== undefined ? (
        <Row
          name="Finance Costs"
          key="Finance Costs"
          total={data["Finance Costs"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Total Benefits, Claims And Other Expenses"] !== undefined ? (
        <Row
          name="Total Benefits, Claims And Other Expenses"
          key="Total Benefits, Claims And Other Expenses"
          total={data["Total Benefits, Claims And Other Expenses"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Profit/Loss Before Share Of Profit Of Associate"] !== undefined ? (
        <Row
          name="Profit/Loss Before Share Of Profit Of Associate"
          key="Profit/Loss Before Share Of Profit Of Associate"
          total={data["Profit/Loss Before Share Of Profit Of Associate"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Share Of Loss Of Associate"] !== undefined ? (
        <Row
          name="Share Of Loss Of Associate"
          key="Share Of Loss Of Associate"
          total={data["Share Of Loss Of Associate"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Share Of Associates Profit"] !== undefined ? (
        <Row
          name="Share Of Associates Profit"
          key="Share Of Associates Profit"
          total={data["Share Of Associates Profit"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["PBT"] !== undefined ? (
        <Row
          name="PBT"
          key="PBT"
          total={data["PBT"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Income Taxes"] !== undefined ? (
        <Row
          name="Income Taxes"
          key="Income Taxes"
          total={data["Income Taxes"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
      {data["Net Income"] !== undefined ? (
        <Row
          name="Net Income"
          key="Net Income"
          total={data["Net Income"]}
          currency={data["currency"]}
        />
      ) : (
        <></>
      )}
    </TableBody>
  );
}
